module.exports = __webpack_public_path__ + "static/media/project.a27a4891.svg";